const model = [
  {
    key: 'campaignId',
    label: 'Campaign Id',
    minWidth: 100,
  },
  {
    key: 'shopUserId',
    label: 'User ID',
    minWidth: 150,
  },
  {
    key: 'invoiceNumber',
    label: 'Invoice Number',
    minWidth: 150,
  },
  { key: 'accountCode', label: 'Account Code', minWidth: 110 },
  {
    key: 'userEmail',
    label: 'Email',
    minWidth: 100,
  },
  {
    key: 'legacyPostId',
    label: 'Product ID',
    minWidth: 100,
  },
  {
    key: 'sku',
    label: 'SKU',
    minWidth: 100,
  },
  {
    key: 'shippingState',
    label: 'Ship State',
    minWidth: 150,
  },
  {
    key: 'shippingCountry',
    label: 'Ship Country',
    minWidth: 150,
  },
  {
    key: 'productName',
    label: 'Name',
    minWidth: 150,
    type: 'string',
  },
  {
    key: 'quantity',
    label: 'Quantity',
    minWidth: 150,
  },
  {
    key: 'salePrice',
    label: 'Sale Price',
    minWidth: 150,
  },
  {
    key: 'createdTs',
    label: 'Created At',
    minWidth: 150,
  },
  {
    key: 'windowType',
    label: 'Window Type',
    minWidth: 150,
  },
];

export default model;
